/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class DataModelKey {
  static readonly ENTITY = 'kit-data/model/entity';
  static readonly DATA_QUERY = 'kit-data/model/data-query';
}
